import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getTranches = async () => {
    const tranches = await axios.get('/service/tranches')
    .catch((e) => {
        throw new CustomException(e, 'Error fetching tranches')
    })
    return tranches.data
}

export const postTranche = async tranche => {
    const trancheRemote = await axios.post('/service/tranche', tranche)
    .catch((e) => {
        throw new CustomException(e, 'Error posting tranche')
    })
    return trancheRemote.data
}
